<template>
  <card class="competition-card" :has-content-padding="false" v-if="showCompetitionCard">
    <div class="competition-card-inner">
      <img class="trophy" :src="require('@public/images/ambassadors/competition-card-bg-2026.png')" alt=""/>
      <div class="text-content">
        <div class="title ri-bold-title">{{ title }}</div>
        <tag class="dates ri-small-body" v-bind="tagProps"/>
        <div class="counter">
          <div class="counter-number">{{ referralsCount }}</div>
          <div class="counter-label">חברים שהצטרפו</div>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'CompetitionCard',
  components: {
    Card: BaseUI.Card,
    Tag: BaseUI.Tag,
  },
  computed: {
    ...mapGetters('referrals', ['competitionDates', 'competitionEvents', 'showCompetitionCard']),
    referralsCount() {
      return this.competitionEvents?.activations || 0;
    },
    title() {
      return `תחרות השגרירים ${moment(this.competitionDates.start).format('YYYY')}`;
    },
    tagProps() {
      const formattedStartDate = moment(this.competitionDates.start).format('D/MM');
      const formattedEndDate = moment(this.competitionDates.end).format('D/MM');
      return {
        text: `${formattedEndDate} - ${formattedStartDate}`,
        textColor: '#FEEEF1',
        backgroundColor: BaseUI.Colors.riseupBlue,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/spacings';

.competition-card {
  background-color: #DEE2F1 !important;
  overflow: hidden;
}

.competition-card ::v-deep .card-body {
  overflow: hidden;
}

.competition-card-inner {
  position: relative;
  height: 212px;
  overflow: hidden;
}

.trophy {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100%;
  width: auto;
  pointer-events: none;
  user-select: none;
}

.text-content {
  position: absolute;
  top: $ri-spacing-ml;
  right: $ri-spacing-ml;
  bottom: $ri-spacing-ml;
  width: 45%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: right;
  gap: $ri-spacing-xs;
  direction: rtl;
}

.title {
  color: $riseup_red;
}

.dates {
  width: fit-content;
  height: 16px;
  padding: 1px $ri-spacing-xs;
  margin-top: $ri-spacing-xs;
}

.counter {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: $riseup_red;
  margin-top: auto;

  .counter-number {
    font-family: 'SimplerPro', sans-serif;
    font-size: 36px;
    line-height: 46px;
    font-weight: 700;
  }

  .counter-label {
    font-family: 'SimplerPro', sans-serif;
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
  }
}
</style>
